<template>
    <v-container :fluid="$vuetify.breakpoint.md">
        <v-row justify="center">
            <v-col cols="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary warning--text py-0"
                                  style="word-break: normal">CONVERSIÓN DE DIVISAS
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-card flat class="pa-0" :class="!$props.user ? 'mb-14' : ''">
            <v-row justify="space-around" v-if="$vuetify.breakpoint.smAndUp">
                <template v-for="country in countries">
                    <v-avatar size="40px" class="ma-1">
                        <img :src="'/img/country/' + country.code + '.png'" :alt="country.name.toLowerCase()"/>
                    </v-avatar>
                </template>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="10" md="8">
                    <v-row justify="center">
                        <v-col cols="12" class="py-2">
                            <h3 class="text-center grey--text text--darken-1">TU ENVIAS</h3>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                            <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                            <v-currency-field
                                :label="labels.value"
                                v-model="form.amount"
                                name="amount"
                                filled
                                hide-details
                                :error-messages="errors.amount"
                                :rules="[rules.required('value'), rules.minus('value', form.amount, min, 'El'), rules.maxim('value', form.amount, max, 'El')]"
                                :disabled="loading"
                                @input="clearErrors('amount')"
                                @keyup="form.amount > 0 ? getCalculate() : null"
                                v-bind="currency_send"
                                v-else/>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                            <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                            <v-select
                                :label="labels.currency"
                                :items="senders"
                                name="cSend"
                                v-model="form.cSend"
                                :error-messages="errors.cSend"
                                :disabled="loading"
                                :rules="[rules.req('currency')]"
                                @select="clearErrors('cSend')"
                                hide-details
                                filled
                                v-else>
                                <template v-slot:selection="{ item }">
                                    <v-flex>
                                        <v-avatar size="28px">
                                            <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country" />
                                        </v-avatar>
                                        <span class='ml-1'>{{ item.code }}{{ item.bank != null ? " - " + item.bankName : "" }}</span>
                                    </v-flex>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-avatar>
                                        <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country"/>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="$vuetify.breakpoint.xsOnly ? item.code : item.code"/>
                                        <v-list-item-subtitle>{{ item.bankName }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="10" md="8">
                    <v-row justify="center">
                        <v-col cols="12" class="pb-0">
                            <v-skeleton-loader class="my-4 mx-auto" width="100%" height="60px" type="image" style="border: 1px solid #ddd; border-radius: 5px" v-if="loading === true"/>
                            <div class="pa-3 bg text-center primary--text" style="border: 1px solid #ddd; border-radius: 5px" v-else>
                                <span>
                                    <strong><v-icon>mdi-minus-box</v-icon> Costo de Envío:</strong>
                                    {{ form.feeIn ? Number(form.feeIn).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cSend.code }}
                                </span>
                                <br>
                                <span>
                                    <strong><v-icon>mdi-equal-box</v-icon> Monto a Convertir:</strong>
                                    {{ form.vSend ? Number(form.vSend).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cSend.code }}
                                </span>
                                <br>
                                <span>
                                    <strong><v-icon>mdi-{{ (form.type === 'sell' ? 'division' : 'close') }}-box</v-icon> Tasa de Cambio:</strong>
                                    {{ form.fx ? Number(form.fx).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 7}) : 0 }}
                                </span>
                                <br>
                                <span>
                                    <strong><v-icon>mdi-minus-box</v-icon> Costo de Pago:</strong>
                                    {{ form.feeOut ? Number(form.feeOut).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cReceiver.code }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="10" md="8">
                    <v-row justify="center">
                        <v-col cols="12" class="py-2">
                            <h3 class="text-center grey--text text--darken-1">TU DESTINATARIO RECIBE</h3>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                            <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                            <v-currency-field
                                :label="labels.value"
                                v-model="form.vReceiver"
                                name="vReceiver"
                                filled
                                hide-details
                                :error-messages="errors.vReceiver"
                                :rules="[rules.required('value')]"
                                :disabled="loading"
                                @input="clearErrors('vReceiver')"
                                @keyup="form.vReceiver > 0 ? getCalculate(2) : null"
                                v-bind="currency_receiver"
                                v-else/>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                            <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                            <v-select
                                :label="labels.currency"
                                :items="receivers"
                                name="cReceiver"
                                v-model="form.cReceiver"
                                :error-messages="errors.cReceiver"
                                :disabled="loading"
                                :rules="[rules.req('currency')]"
                                @select="clearErrors('cReceiver')"
                                hide-details
                                filled
                                v-else>
                                <template v-slot:selection="{ item }">
                                    <v-flex>
                                        <v-avatar size="28px">
                                            <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country" />
                                        </v-avatar>
                                        <span class='ml-1'>{{ item.code }}{{ item.bank != null ? " - " + item.bankName : "" }}</span>
                                    </v-flex>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-avatar>
                                        <img :src="'/img/country/' + (item.country ?? '000') + '.png'" :alt="item.country"/>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="$vuetify.breakpoint.xsOnly ? item.code : item.code"/>
                                        <v-list-item-subtitle>{{ item.bankName }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="10" md="8">
                    <v-row justify="center">
                        <v-col cols="12" class="py-0">
                            <v-skeleton-loader class="my-4 mx-auto" width="100%" height="58px" type="image"
                                               style="border: 1px solid #ddd; border-radius: 5px" v-if="loading === true"/>
                            <div class="pa-3 bg text-center primary--text" style="border: 1px solid #ddd; border-radius: 5px" v-else>
                                <span>
                                    <strong><v-icon>mdi-minus-box</v-icon> Monto Mínimo:</strong>
                                    {{ min ? Number(min).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cSend.code }}
                                </span>
                                <br>
                                <span>
                                    <strong><v-icon>mdi-plus-box</v-icon> Monto Máximo:</strong>
                                    {{ max ? Number(max).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2}) : 0 }} {{ form.cSend.code }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="10" md="8" class="pb-2">
                            <h4 class="text-center" v-if="loading !== true">El resultado no contiene comisiones bancarias</h4>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="$props.user && $props.user.role === 'Customer'">
                        <v-col cols="12" md="10" lg="8" class="text-center">
                            <v-btn color="primary" :to="{name: 'Request'}">
                                <v-icon>mdi-cash-100</v-icon>&nbsp;&nbsp;ENVIAR DINERO
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>


<script>
import axios from "axios";
import Form from "../helpers/form";

export default {
    name: "Calculator",
    mixins: [Form],
    props: ['user'],
    data: () => ({
        loading: true,
        countries: [
            { name: 'Venezuela', code: 'VEN' },
            { name: 'Colombia', code: 'COL' },
            { name: 'Perú', code: 'PER' },
            { name: 'Chile', code: 'CHL' },
            { name: 'Ecuador', code: 'ECU' },
            { name: 'Europa', code: 'EUR' },
            { name: 'Brasil', code: 'BRA' },
            { name: 'México', code: 'MEX' },
            { name: 'Panamá', code: 'PAN' },
            { name: 'Estados Unidos', code: 'USA' }
        ],
        rates: [],
        fees: {},
        limits: {},
        senders: [],
        receivers: [],
        labels: {
            value: 'Valor',
            currency: 'Moneda'
        },
        form: {
            amount: 0,
            feeIn: 0,
            vSend: 0,
            cSend: '',
            type: '',
            fx: 0,
            feeOut: 0,
            vReceiver: 0,
            cReceiver: ''
        },
        min: null,
        max: null,
        currency_send: {
            locale: 'en-US',
            decimalLength: 2,
            autoDecimalMode: false,
            min: null,
            max: null,
            defaultValue: 0,
            valueAsInteger: false,
            allowNegative: false
        },
        currency_receiver: {
            locale: 'en-US',
            decimalLength: 2,
            autoDecimalMode: false,
            min: null,
            max: null,
            defaultValue: 0,
            valueAsInteger: false,
            allowNegative: false
        },
    }),
    mounted() {
        this.getData();
    },
    watch: {
        'user.country'() {
            this.form.cSend = '';
            this.getSenders();
        },
        'form.cSend'() {
            this.getParams();
            this.getReceivers();
        },
        'form.cReceiver'() {
            this.getSenders()
            this.getCalculate();
        }
    },
    methods: {
        getData() {
            clearTimeout(this.timeout);
            axios.get('/api/currencies/all').then((res) => {
                this.rates = res.data.rates;
                this.fees = res.data.fees;
                this.limits = res.data.limits;
            }).catch(err => {
                this.handleErrors(err.response.data.errors);
            }).then(() => {
                this.getSenders();
                this.loading = false;
            });
            this.timeout = setTimeout(this.getData, 300000);
        },
        getSenders() {
            const rates = this.rates;
            const receiver = this.form.cReceiver;
            let senders = [];
            for (let i = 0; i < rates.length; i++) {
                if (receiver.country !== rates[i].country_send) {
                    const a = {
                        country: rates[i].country_send,
                        code: rates[i].currency_send,
                        digits: rates[i].currency_send_dd,
                        bank: rates[i].bank_send,
                        bankName: rates[i].bank_send_name
                    }
                    let v = (JSON.stringify(senders)).includes(JSON.stringify(a));
                    if (v === false) {
                        senders.push(a);
                        if ((this.form.cSend).length === 0 && rates[i].country_send === this.user.country) {
                            this.form.cSend = a;
                        }
                    }
                }
            }
            this.senders = senders;
            this.getParams();
        },
        getParams() {
            let limits = this.limits;
            let min = limits['min'];
            let max = limits['max'];
            let currency = this.form.cSend.code;

            for (let i = 0; i < min.length; i++) {
                if (min[i].data.currency === currency) {
                    this.min = parseInt(min[i].data.value);
                }
            }

            for (let i = 0; i < max.length; i++) {
                if (max[i].data.currency === currency) {
                    this.max = parseInt(max[i].data.value);
                }
            }
        },
        getReceivers() {
            const rates = this.rates;
            const sender = this.form.cSend;
            const receiver = this.form.cReceiver;
            let receivers = [];
            for (let i = 0; i < rates.length; i++) {
                if (sender.country === rates[i].country_send &&
                    sender.code === rates[i].currency_send &&
                    sender.bank === rates[i].bank_send) {
                    const a = {
                        country: rates[i].country_receiver,
                        code: rates[i].currency_receiver,
                        digits: rates[i].currency_receiver_dd,
                        bank: rates[i].bank_receiver,
                        bankName: rates[i].bank_receiver_name
                    }
                    let v = (JSON.stringify(receivers)).includes(JSON.stringify(a));
                    if (v === false) {
                        receivers.push(a);
                    }
                }
            }
            this.receivers = receivers;
            if (receiver.length === 0 || sender === receiver) {
                this.form.cReceiver = receivers[0];
            }
            this.getSenders();
            this.getCalculate();
        },
        getCalculate(n) {
            let feeIn = this.form.feeIn;
            let feeOut = this.form.feeOut;
            let type = null;
            let rate = 0;
            let value = this.form.amount;
            let send = 0;
            let result = this.form.vReceiver;
            const rates = this.rates;
            const fees = this.fees;
            const sender = this.form.cSend;
            const receiver = this.form.cReceiver;
            for (let i = 0; i < rates.length; i++) {
                if (sender.country === rates[i].country_send &&
                    sender.code === rates[i].currency_send &&
                    sender.bank === rates[i].bank_send &&
                    receiver.country === rates[i].country_receiver &&
                    receiver.code === rates[i].currency_receiver &&
                    receiver.bank === rates[i].bank_receiver) {
                    type = rates[i].type;
                    rate = rates[i].value;
                }
            }
            if (n === 2) {
                feeOut = 0;
                let b1 = false;
                let b2 = false;
                let b3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'Out' && parseFloat(fees[i].value) > 0) {
                        if (result >= fees[i].range_min && result <= fees[i].range_max) {
                            if (fees[i].currency === receiver.code || (b1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === receiver.code) {
                                    b1 = true;
                                }
                                if (fees[i].country_receiver === receiver.country || (b2 === false && fees[i].country_receiver === null)) {
                                    if (fees[i].country_receiver === receiver.country) {
                                        b2 = true;
                                    }
                                    if (fees[i].country_send === sender.country || (b3 === false && fees[i].country_send === null)) {
                                        if (fees[i].country_send === sender.country) {
                                            b3 = true;
                                        }
                                        if (fees[i].type === '%') {
                                            feeOut = (parseFloat(result) * (1 + (parseFloat(fees[i].value) / 100))) - parseFloat(result);
                                        } else if (fees[i].type === '$') {
                                            feeOut = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                result = parseFloat(result) + feeOut;
                send = type === 'sell' ? result * parseFloat(rate) : result / parseFloat(rate);
                feeIn = 0;
                let c1 = false;
                let c2 = false;
                let c3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'In' && parseFloat(fees[i].value) > 0) {
                        if (send >= fees[i].range_min && send <= fees[i].range_max) {
                            if (fees[i].currency === sender.code || (c1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === sender.code) {
                                    c1 = true;
                                }
                                if (fees[i].country_send === sender.country || (c2 === false && fees[i].country_send === null)) {
                                    if (fees[i].country_send === sender.country) {
                                        c2 = true;
                                    }
                                    if (fees[i].country_receiver === receiver.country || (c3 === false && fees[i].country_receiver === null)) {
                                        if (fees[i].country_receiver === receiver.country) {
                                            c3 = true;
                                        }
                                        if (fees[i].type === '%') {
                                            feeIn = (parseFloat(send) * (1 + (parseFloat(fees[i].value) / 100))) - parseFloat(send);
                                        } else if (fees[i].type === '$') {
                                            feeIn = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.form.amount = parseFloat(send) + feeIn;
            } else {
                feeIn = 0;
                let c1 = false;
                let c2 = false;
                let c3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'In' && parseFloat(fees[i].value) > 0) {
                        if (value >= fees[i].range_min && value <= fees[i].range_max) {
                            if (fees[i].currency === sender.code || (c1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === sender.code) {
                                    c1 = true;
                                }
                                if (fees[i].country_send === sender.country || (c2 === false && fees[i].country_send === null)) {
                                    if (fees[i].country_send === sender.country) {
                                        c2 = true;
                                    }
                                    if (fees[i].country_receiver === receiver.country || (c3 === false && fees[i].country_receiver === null)) {
                                        if (fees[i].country_receiver === receiver.country) {
                                            c3 = true;
                                        }
                                        if (fees[i].type === '%') {
                                            feeIn = parseFloat(value) - (parseFloat(value) / (1 + (parseFloat(fees[i].value) / 100)));
                                        } else if (fees[i].type === '$') {
                                            feeIn = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                send = parseFloat(value) - feeIn;
                result = type === 'sell' ? send / parseFloat(rate) : send * parseFloat(rate);
                feeOut = 0;
                let b1 = false;
                let b2 = false;
                let b3 = false;
                for (let i = 0; i < fees.length; i++) {
                    if (fees[i].category === 'Out' && parseFloat(fees[i].value) > 0) {
                        if (result >= fees[i].range_min && result <= fees[i].range_max) {
                            if (fees[i].currency === receiver.code || (b1 === false && fees[i].currency === null)) {
                                if (fees[i].currency === receiver.code) {
                                    b1 = true;
                                }
                                if (fees[i].country_receiver === receiver.country || (b2 === false && fees[i].country_receiver === null)) {
                                    if (fees[i].country_receiver === receiver.country) {
                                        b2 = true;
                                    }
                                    if (fees[i].country_send === sender.country || (b3 === false && fees[i].country_send === null)) {
                                        if (fees[i].country_send === sender.country) {
                                            b3 = true;
                                        }
                                        if (fees[i].type === '%') {
                                            feeOut = parseFloat(result) - (parseFloat(result) / (1 + (parseFloat(fees[i].value) / 100)));
                                        } else if (fees[i].type === '$') {
                                            feeOut = parseFloat(fees[i].value);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.form.vReceiver = parseFloat(result) - feeOut;
            }
            this.form.feeIn = feeIn.toFixed(sender.digits);
            this.form.vSend = send;
            this.form.type = type;
            this.form.fx = rate;
            this.form.feeOut = feeOut.toFixed(receiver.digits);
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
